// Off-the-clock section. `icon` must match a key in components/Hobbies.js.

export const hobbies = [
  { icon: "anime", title: "Anime", text: "Watching anime. There's a reason this site looks the way it does." },
  { icon: "walk", title: "Walks", text: "Going on long walks. It's the easiest way I know to clear and reset my mind." },
  { icon: "soccer", title: "Soccer", text: "Playing whenever there's a game going." },
];
